import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";

const StudentResults = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Student Results</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/studentresults">Student Results</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-student-results">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-10 offset-xl-1 col-12">
              <div className="student-results-inner">
                <div class="student-results-top">
                  <div class="row">
                    <div class="col-12">
                      <div class="student-r-top-form">
                        <form action="#" method="post">
                          <div class="row align-items-center">
                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <label>Select Class</label>
                                <select
                                  class="form-select"
                                  aria-label="Default select example"
                                >
                                  <option>Class one</option>
                                  <option value="1">Class two</option>
                                  <option value="2">Class three</option>
                                  <option value="4">Class four</option>
                                  <option value="5">Class five</option>
                                  <option value="6">Class six</option>
                                  <option value="7">Class seven</option>
                                  <option value="8">Class eight</option>
                                  <option value="9">Class nine</option>
                                  <option value="10">Class ten</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <label>Select Group</label>
                                <select
                                  class="form-select"
                                  aria-label="Default select example"
                                >
                                  <option>Humanities</option>
                                  <option value="1">Business Studies</option>
                                  <option value="2">Science</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <label>Select Exam</label>
                                <select
                                  class="form-select"
                                  aria-label="Default select example"
                                >
                                  <option>First term</option>
                                  <option value="1">Mid term</option>
                                  <option value="2">Final exam</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <label>Student Roll</label>
                                <input
                                  type="text"
                                  name="student-roll"
                                  required
                                />
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <label>Select year</label>
                                <select
                                  class="form-select"
                                  aria-label="Default select example"
                                >
                                  <option>2022</option>
                                  <option value="1">2021</option>
                                  <option value="2">2020</option>
                                  <option value="4">2019</option>
                                  <option value="5">2018</option>
                                  <option value="6">2017</option>
                                  <option value="7">2016</option>
                                  <option value="8">2015</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-12">
                              <div class="form-group">
                                <button class="search-btn" type="submit">
                                  <i class="fi fi-rr-search"></i>Search{" "}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="student-result-data">
                  <div className="student-result-data-top">
                    <span className="st-class-name">Class name</span>
                    <span className="st-group">Group</span>
                    <span className="st-exam">Exam Name</span>
                    <span className="st-name">Student Name</span>
                    <span className="st-rool">Student roll</span>
                    <span className="st-grade">Grade</span>
                    <span className="st-result">Results</span>
                    <span className="st-action">Action</span>
                  </div>
                  <div className="student-result-data-main">
                    <div className="student-result-data-single">
                      <span className="class-name">Class Ten</span>
                      <span className="group">G-A</span>
                      <span className="exam-name">First Term</span>
                      <span className="student-name">Shahriar Hossain</span>
                      <span className="class-roll">01</span>
                      <span className="grade">A+</span>
                      <span className="result">Pass</span>
                      <span className="action-btn">
                        <a href="#" className="view-detail-btn">
                          View details
                        </a>
                      </span>
                    </div>
                    <div className="student-result-data-single">
                      <span className="class-name">Class Ten</span>
                      <span className="group">G-B</span>
                      <span className="exam-name">First Term</span>
                      <span className="student-name">Rahil Uddin</span>
                      <span className="class-roll">02</span>
                      <span className="grade fail">F</span>
                      <span className="result fail">Fail</span>
                      <span className="action-btn">
                        <a href="#" className="view-detail-btn">
                          View details
                        </a>
                      </span>
                    </div>
                    <div className="student-result-data-single">
                      <span className="class-name">Class Ten</span>
                      <span className="group">G-C</span>
                      <span className="exam-name">First Term</span>
                      <span className="student-name">Nadim Hossain</span>
                      <span className="class-roll">03</span>
                      <span className="grade">A+</span>
                      <span className="result">Pass</span>
                      <span className="action-btn">
                        <a href="#" className="view-detail-btn">
                          View details
                        </a>
                      </span>
                    </div>
                    <div className="student-result-data-single">
                      <span className="class-name">Class Ten</span>
                      <span className="group">G-C</span>
                      <span className="exam-name">First Term</span>
                      <span className="student-name">Jehad Hossain</span>
                      <span className="class-roll">04</span>
                      <span className="grade fail">f</span>
                      <span className="result fail">fail</span>
                      <span className="action-btn">
                        <a href="#" className="view-detail-btn">
                          View details
                        </a>
                      </span>
                    </div>
                    <div className="student-result-data-single">
                      <span className="class-name">Class Ten</span>
                      <span className="group">G-C</span>
                      <span className="exam-name">First Term</span>
                      <span className="student-name">Meheraj Hossain</span>
                      <span className="class-roll">05</span>
                      <span className="grade">A+</span>
                      <span className="result">Pass</span>
                      <span className="action-btn">
                        <a href="#" className="view-detail-btn">
                          View details
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="eschool-notice-board-bottom">
                  <div className="notice-board-bottom-button">
                    <Link to="#" className="single-btn prev-btn">
                      <i class="fi fi-rr-arrow-left"></i>Previous Page
                    </Link>
                    <Link to="#" className="single-btn next-btn">
                      Next Page<i class="fi fi-rr-arrow-right"></i>
                    </Link>
                  </div>
                  <div className="notice-board-btm-page-number">
                    <form action="#" method="post">
                      <p>
                        Page <input type="text" placeholder="1" required /> of
                        100
                      </p>
                      <button
                        type="submit"
                        className="notice-btm-page-number-btn"
                      >
                        Go
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StudentResults;
